import { ClockHistoryOutlined } from 'components/Shared/Icons';

import styles from './styles.module.css';

type LastNotAuthorizedMessageProps = {
  open: boolean;
};

const LastNotAuthorizedMessage = ({ open }: LastNotAuthorizedMessageProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className={styles.container}>
      <ClockHistoryOutlined color='#EF4444' />
      <p className={styles.text}>Última Entrada Não Autorizada</p>
    </div>
  );
};

export default LastNotAuthorizedMessage;
